import React from 'react'

const Navbar = () => {
    return (
        <div className = "navbar">
            <div className="navbar-text">
            where in the world?
            </div>      
        </div>
    )
}

export default Navbar
